import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from 'react';
import { Grid } from '@mui/material';
import { ReactComponent as Maximize } from '../../assets/Maximize.svg';
import { FixedButton } from './style';
import { useTypedTheme } from '@monorepo-web/styles';
/**
 * Bot�o fixo no canto inferior direito.
 * Ele aparece apenas quando o usu�rio minimiza o modal de loading.
 */
const FixedLoadingButton = ({ loading, isLoadingMinimized, handleClick }) => {
    const theme = useTypedTheme();
    useEffect(() => {
        if (!loading && isLoadingMinimized) { // remover o bot�o se terminar o loading
            handleClick(false);
        }
    }, [loading, isLoadingMinimized]);
    return (_jsx(Grid, Object.assign({ display: (loading && isLoadingMinimized) ? 'flex' : 'none' }, { children: _jsxs(FixedButton, Object.assign({ onClick: () => handleClick(false) }, { children: [_jsx(Maximize, { fill: theme.fontColorMenu, style: { marginRight: '5px' } }), "Carregando"] })) })));
};
export default FixedLoadingButton;
